import { render, staticRenderFns } from "./Damaged_product.vue?vue&type=template&id=44ae7277&scoped=true&"
import script from "./Damaged_product.vue?vue&type=script&lang=js&"
export * from "./Damaged_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ae7277",
  null
  
)

export default component.exports